import React, { lazy, Suspense, useState } from "react";

import { LANGUAGES, useI18n } from "../../i18n";

const LanguageDialog = lazy(() => import("./LanguageDialog"));

export default function LanguageToggle() {
  const { lang, t } = useI18n();
  const [open, setOpen] = useState(false);
  const current = LANGUAGES.find((l) => l.code === lang) || LANGUAGES[0];

  return (
    <>
      <button type="button" className="f-topbar-chip" onClick={() => setOpen(true)} aria-label={t("lang.label")}>
        <img src={current.flag} width="18" height="18" alt="" style={{ borderRadius: 999, objectFit: "cover" }} />
        {current.short}
      </button>

      {open && (
        <Suspense fallback={null}>
          <LanguageDialog isOpen={open} toggle={() => setOpen(false)} />
        </Suspense>
      )}
    </>
  );
}
